/*
 * Copyright 2019 WeBank
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export default {
  'zh-CN': {
    'vue-process': {
      'Basic': '基础信息',
      'node name': '节点名',
      'enter node name': '请输入节点名',
      'describe': '描述',
      'enter-desc': '请输入描述',
      'save': '保存',
      'amplification': '放大',
      'narrow': '缩小',
      'fullscreen': '全屏/取消全屏',
      'format': '一键格式化',
      'return format': '恢复到格式化之前的状态',
      'straight': '直线',
      'slash': '斜线',
      'Width': '节点宽度',
      'formatting': '格式化',
      'cancel': '取消',
      'Whether return format': '是否要恢复到格式化之前的状态？',
      'restore': '恢复',
      'zoom-max': '放大的极限是',
      'zoom-min': '缩小的极限是',
      'copy': '复制',
      'delete': '删除',
      'Parameter': '参数配置',
      'cannot be formatted': '无节点时无法进行格式化！',
      'Unable to connect': '不能连接自己！',
      'repeat nodes': '不能重复连接两个节点！',
      'closed-loop': '不能形成闭环！',
      'paste': '粘贴',
      'parameter': '参数',
      'attribute': '属性',
      'value': '值',
      'attribute name': '请输入属性名',
      'property value': '请输入属性值',
      'search': '搜索',
      
    }
  },
  'en': {
    'vue-process': {
      'Basic': 'Basic information',
      'node name': 'Node Name',
      'enter node name': 'Please enter the node name',
      'describe': 'Description',
      'enter-desc': 'Please enter description',
      'save': 'Save',
      'amplification': 'Zoom out',
      'narrow': 'Zoom in',
      'fullscreen': 'fullscreen/exit',
      'format': 'Format',
      'return format': 'Revert format',
      'straight': 'Straight',
      'slash': 'Slash',
      'Width': 'Width',
      'formatting': 'Format',
      'cancel': 'cancel',
      'Whether return format': 'Whether or not to return to format before?',
      'restore': 'restore',
      'zoom-max': 'Max zoom',
      'zoom-min': 'Min zoom',
      'copy': 'Copy',
      'delete': 'Delete',
      'Parameter': 'Parameter',
      'cannot be formatted': 'Cannot be formatted',
      'Unable to connect': 'Unable to connect itself',
      'repeat nodes': "Can't repeat connect!",
      'closed-loop': 'Unable to connect！',
      'paste': 'Paste',
      'parameter': 'parameter',
      'attribute': 'attribute',
      'value': 'value',
      'attribute name': 'Please enter attribute name',
      'property value': 'Please enter value',
      'search': 'search'
    }
  }
};
